import React from 'react';
import Card from '../Card/Card';
import CardWithImage from '../Card/CardWithImage'
import _ from 'lodash';
import Paragraph from './Paragraph';

const CardWrapper = ({ entity }) => {

  const props = {
    children: null
  }

  let imageUrl = _.get(entity, 'fieldIcon.entity.fieldMediaIcon.entity.uri.url', null)
  let hasFullWidthImage = false
  let altText = _.get(entity, 'fieldAltText', null)

  if (!imageUrl) {
    imageUrl = _.get(entity, 'fieldBackground.entity.fieldMediaImage.cardImage.image.childImageSharp', null)
    hasFullWidthImage = true
  }

  const Component = imageUrl ? CardWithImage : Card

  if (entity.fieldItems.length > 0) {
    props.children = entity.fieldItems.map((item) => (
      <Paragraph key={item.entity.entityId} entity={item.entity} />
    ))
  }
  return (
   <Component
      key={entity.entityId}
      type={_.get(entity, 'fieldCardType', 'default')}
      titleTag={_.get(entity, 'fieldTitleTag', 'h2')}
      title={entity.fieldTitle || ''}
      text={entity.fieldText}
      image={imageUrl}
      hasFullWidthImage={hasFullWidthImage}
      altText={altText}
      url={_.get(entity, 'fieldMoreLink.url.path')}
      linkText={_.get(entity, 'fieldMoreLink.title', null)}
      linkLabel={_.get(entity, 'fieldMoreLinkLabel', null)}
      linkType={_.get(entity, 'fieldMoreLinkType', null)}
      url2={_.get(entity, 'fieldMoreLinkTwo.url.path')}
      linkText2={_.get(entity, 'fieldMoreLinkTwo.title', null)}
      linkLabel2={_.get(entity, 'fieldMoreLinkLabelTwo', null)}
      linkType2={_.get(entity, 'fieldMoreLinkTypeTwo', null)}
      icon={imageUrl}
      {...props}
   />
  );
}

CardWrapper.propTypes = {

};

export default CardWrapper;
